import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export interface IConfirmPaymentPayload {
  category_id: number;
  service_id: number;
  required_data: Record<string, any>;
  fees: number;
  amount: number;
  bill_id: number[];
  save_bill?: boolean;
  bill_name?: string;
}

export const confirmPayment = (payload: IConfirmPaymentPayload) => {
  const { save_bill, bill_name, ...rest } = payload;
  const data = save_bill ? { ...rest, save_bill, bill_name } : rest;

  return axiosPrivate.post('/bills/api/v1/payment/confirm/', data);
};
